<section class="fb-login w-full flex justify-center items-center min-h-[90vh] bg-[#fffcf7]">
	<div class="w-full max-w-[956px] min-h-[67vh] bg-white rounded-2xl p-3 md:p-6 m-3 drop-shadow-xl
	flex flex-col md:flex-row justify-between items-stretch gap-3">
		<div class="md:flex-[50%] flex justify-center items-center">
			<fb-auth-methods *ngIf="authProvider === AuthProviderEnum.UNKNOWN"
							 (authProvider)="selectAuthProvider($event)"></fb-auth-methods>
			<fb-auth-social-method *ngIf="authProvider === AuthProviderEnum.GOOGLE || authProvider === AuthProviderEnum.FACEBOOK"
								   (authProvider)="selectAuthProvider($event)"
								   [aProvider]="authProvider"></fb-auth-social-method>
			<ng-container *ngIf="!(tenantStatus.registered && !tenantStatus.emailVerified) &&  !shouldLogin && !shouldRegister">
				<fb-auth-email-method *ngIf="authProvider === AuthProviderEnum.BASIC"
									  (authProvider)="selectAuthProvider($event)"
									  (email)="getUserEmail($event.value)"></fb-auth-email-method>
			</ng-container>

			<ng-container *ngIf="tenantStatus.registered && !tenantStatus.emailVerified">
				<fb-verify-email-form [emailFormControl]="emailFormControl"
									  (authProvider)="selectAuthProvider($event)"/>
			</ng-container>
			<ng-container *ngIf="shouldLogin">
				<fb-login class="w-full" [emailFormControl]="emailFormControl"
						  (authProvider)="selectAuthProvider($event)" />
			</ng-container>
			<ng-container *ngIf="shouldRegister">
				<fb-register class="w-full" [emailFormControl]="emailFormControl"
						  (authProvider)="selectAuthProvider($event)" />
			</ng-container>
		</div>
		<div class="md:flex-[50%] rounded-2xl overflow-hidden relative flex justify-center items-center">

			<img ngSrc="assets/img/auth.jpeg"
				 width="400"
				 height="500"
				 class="w-full h-full object-cover"
				 alt="Anuprerna">
		</div>
	</div>
</section>
